import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'
import * as MISSION_CONST from './../Mission/const'
// A hash maps of city plans id => data
const defaultState = {}

export const cityPlans = function(state = defaultState, action) {
  switch (action.type) {
    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS: {
      return {
        ...state,
        ...(() => {
          var cityPlans = action.result.data.campaign.cityPlans.nodes
          var subObject = {}
          cityPlans.forEach(cityPlan => {
            var missionIds = []
            subObject[cityPlan.id] = Object.assign({}, state[cityPlan.id], {
              id: cityPlan.id,
              cityId: cityPlan.city.id,
              distributionCost: cityPlan.distributionCost,
              payHourly: cityPlan.payHourly,
              payout: cityPlan.payout,
              missionIds,
              permitCostIds: cityPlan.permitCosts.nodes.map(p => p.id),
            })
            cityPlan.missions.edges.forEach(edge =>
              missionIds.push(edge.node.id),
            )
          })
          return subObject
        })(),
      }
    }
    case MISSION_CONST.CREATE_MISSIONS_SUCCESS:
    case MISSION_CONST.PUBLISH_MISSIONS_SUCCESS:
      var subObject = Object.assign({}, state)
      action.result.forEach(mission => {
        const { cityPlanId } = mission
        var cityPlan = { ...subObject[cityPlanId] }
        cityPlan.missionIds = cityPlan.missionIds.slice(0)
        if (cityPlan.missionIds.indexOf(mission.id) == -1)
          cityPlan.missionIds.push(mission.id)
        subObject[cityPlanId] = cityPlan
      })
      return {
        ...state,
        ...subObject,
      }
    case MISSION_CONST.DELETE_MISSIONS:
      var stateChanged = false
      Object.keys(state).forEach(cityPlanId => {
        var cityPlan = { ...state[cityPlanId] }
        action.payload.missions.forEach(({ id }) => {
          var index = cityPlan.missionIds.findIndex(o => o == id)
          if (index != -1) {
            stateChanged = true
            state = { ...state }
            state[cityPlanId] = cityPlan
            cityPlan.missionIds = cityPlan.missionIds.slice(0)
            cityPlan.missionIds.splice(index, 1)
          }
        })
      })
      return stateChanged ? { ...state } : state
    default:
      return state
  }
}
